import { _request_KEYCLOAK } from "../../request/_request_KEYCLOAK";

export const getAddress = async (_cnpj, _numeroInterno) => {
  let options = {
    method: "GET",
    url:
      process.env.REACT_APP_TICKET_INT015 +
      `/${_cnpj}/numero-interno/${_numeroInterno}`,
  };

  return new Promise((resolve, reject) => {
    _request_KEYCLOAK(options)
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
